import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { forwardRef, useEffect } from 'react';
import useCustomModal from '@src/v3.0.0/store/custom-modal';
import { useAppStore } from '@src/v3.0.0/store/app';
import l10n from '@src/v3.0.0/lib/l10n';
import styled from "@emotion/styled";
import { Box } from "@mui/material";

const StyledCustomModalContent = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({theme}) => theme.palette.background.paper};
`;

const CustomModal = forwardRef(({ root, children }, ref) => {
  const {open,setOpen,setRef} = useCustomModal();
  const app = useAppStore();

  useEffect(
    () => {
      if (l10n.current_page === 'product') {
        const button = document.querySelector('#btn-customprocess--root .btn-customprocess');
        if ( button ) {   
          const onClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen(true);
          };
          button.addEventListener('click', onClick);
          button.removeAttribute('disabled');
          return () => {
            button.removeEventListener('click', onClick);
            button.setAttribute('disabled', true);
          }
        }
      }
    }, 
    [open, setOpen]
  );

  const onModalClose = () => {
    app.setIdle();
    setOpen(false);
  };

  return <Modal
    ref={setRef}
    id="cp-main-modal"
    open={open}
    onClose={onModalClose}
    closeAfterTransition
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        timeout: 500,
      },
    }}
  >
    <Fade in={open}>
      <StyledCustomModalContent>
        {children}
      </StyledCustomModalContent>
    </Fade>
  </Modal>
});

export default CustomModal;